import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function AuthoritySection() {
  return <section className="py-20 bg-[#f4f1ea] text-center" data-id="element-18">
      <div className="max-w-3xl mx-auto px-4" data-id="element-19">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white p-10 rounded-2xl shadow-sm border border-stone-200" data-id="element-20">
          <h2 className="text-3xl font-serif font-bold text-gray-900 mb-6" data-id="element-21">
            Autoridad Suave
          </h2>

          <p className="text-lg text-gray-700 leading-relaxed mb-8" data-id="element-22">
            Este libro nace de la experiencia real: de observar procesos
            humanos, momentos de quiebre silencioso y la necesidad de poner
            palabras donde hay confusión.
          </p>

          <p className="text-xl font-medium text-gray-900 italic mb-10" data-id="element-23">
            Está escrito para acompañar, no para imponer.
          </p>

          <CTAButton text="Acompañarme en este momento" className="max-w-sm" data-id="element-24" />
        </motion.div>
      </div>
    </section>;
}